import { InMemoryHeader, InMemoryString, InMemoryDate, InMemoryBoolean, InMemoryInteger } from "pbas-vue-components";

const MemberFilesHeaders = [
  // new InMemoryHeader({
  //   type: new InMemoryString("Identifier"),
  //   visible: false,
  //   isIdentifier: true,
  //   allowVisibilityChange: false
  // }),
  new InMemoryHeader({
    title: "headers.members_management.Effective Date",
    type: new InMemoryDate("EffectiveDate"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
    isIdentifier: true,
  }),
  new InMemoryHeader({
    title: "headers.members_management.Termination Date",
    type: new InMemoryDate("TerminationDate"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new InMemoryHeader({
    title: "headers.member_termination.has_extensions",
    type: new InMemoryBoolean("HasExtensions"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.member_termination.no_of_extensions",
    type: new InMemoryInteger("NoOfExtensions"),
    sortable: true,
    visible: true,
    searchable: true
  })
];
export default MemberFilesHeaders;
